import * as yup from "yup";

const isEmpty = (value: any) =>
  value === null || value === undefined || value === "";

export const EmployeeBankSetupValidationSchema = yup.object().shape({
  // ACCOUNT 1
  // account1Name: yup
  //   .string()
  //   .nullable()
  //   .test("bank-fields-required", "Bank Name is required", function (value) {
  //     const { account1No, branchTransitNoAccount1, bankFinancialNoAccount1 } =
  //       this.parent;
  //     const anyFilled =
  //       !isEmpty(account1No) ||
  //       !isEmpty(branchTransitNoAccount1) ||
  //       !isEmpty(bankFinancialNoAccount1);

  //     if (anyFilled && isEmpty(value)) return false;
  //     return true;
  //   }),

  account1No: yup
    .string()
    .nullable()
    .test(
      "bank-fields-required",
      "Bank Account No. is required",
      function (value) {
        const {
          account1Name,
          branchTransitNoAccount1,
          bankFinancialNoAccount1,
        } = this.parent;
        const anyFilled =
          !isEmpty(account1Name) ||
          !isEmpty(branchTransitNoAccount1) ||
          !isEmpty(bankFinancialNoAccount1);

        if (anyFilled && isEmpty(value)) return false;
        return true;
      },
    ),

  branchTransitNoAccount1: yup
    .string()
    .nullable()
    .test(
      "bank-fields-required",
      "Branch / Transit No. is required",
      function (value) {
        const { account1Name, account1No, bankFinancialNoAccount1 } =
          this.parent;
        const anyFilled =
          !isEmpty(account1Name) ||
          !isEmpty(account1No) ||
          !isEmpty(bankFinancialNoAccount1);

        if (anyFilled && isEmpty(value)) return false;
        return true;
      },
    ),

  bankFinancialNoAccount1: yup
    .string()
    .nullable()
    .test(
      "bank-fields-required",
      "Bank / Fin Institution No. is required",
      function (value) {
        const { account1Name, account1No, branchTransitNoAccount1 } =
          this.parent;
        const anyFilled =
          !isEmpty(account1Name) ||
          !isEmpty(account1No) ||
          !isEmpty(branchTransitNoAccount1);

        if (anyFilled && isEmpty(value)) return false;
        return true;
      },
    ),

  // ACCOUNT 2
  // account2Name: yup
  //   .string()
  //   .nullable()
  //   .test("bank-fields-required", "Bank Name is required", function (value) {
  //     const { account2No, branchTransitNoAccount2, bankFinancialNoAccount2 } =
  //       this.parent;
  //     const anyFilled =
  //       !isEmpty(account2No) ||
  //       !isEmpty(branchTransitNoAccount2) ||
  //       !isEmpty(bankFinancialNoAccount2);

  //     if (anyFilled && isEmpty(value)) return false;
  //     return true;
  //   }),

  account2No: yup
    .string()
    .nullable()
    .test(
      "bank-fields-required",
      "Bank Account No. is required",
      function (value) {
        const {
          account2Name,
          branchTransitNoAccount2,
          bankFinancialNoAccount2,
        } = this.parent;
        const anyFilled =
          !isEmpty(account2Name) ||
          !isEmpty(branchTransitNoAccount2) ||
          !isEmpty(bankFinancialNoAccount2);

        if (anyFilled && isEmpty(value)) return false;
        return true;
      },
    ),

  branchTransitNoAccount2: yup
    .string()
    .nullable()
    .test(
      "bank-fields-required",
      "Branch / Transit No. is required",
      function (value) {
        const { account2Name, account2No, bankFinancialNoAccount2 } =
          this.parent;
        const anyFilled =
          !isEmpty(account2Name) ||
          !isEmpty(account2No) ||
          !isEmpty(bankFinancialNoAccount2);

        if (anyFilled && isEmpty(value)) return false;
        return true;
      },
    ),

  bankFinancialNoAccount2: yup
    .string()
    .nullable()
    .test(
      "bank-fields-required",
      "Bank / Fin Institution No. is required",
      function (value) {
        const { account2Name, account2No, branchTransitNoAccount2 } =
          this.parent;
        const anyFilled =
          !isEmpty(account2Name) ||
          !isEmpty(account2No) ||
          !isEmpty(branchTransitNoAccount2);

        if (anyFilled && isEmpty(value)) return false;
        return true;
      },
    ),
});
